export default __webpack_public_path__ + "static/media/faq.a451f9ab.svg";